import { BaseDocument } from './BaseDocument';
import { DocumentSnapshot } from '../types/firebaseTypes';
import { UiConfigSchema } from '../schemas/UiConfig';

export class UiConfigDocument extends BaseDocument<UiConfigSchema> {
  constructor(snapshot: DocumentSnapshot<UiConfigSchema>) {
    super(snapshot, 'UiConfig');
  }
}
